<loading-text-display [isLoading]="isPageLoading">
    <div class="container-fluid fall-management-page fall-opt-out-page" [ngClass]="['step-' + currentStep, 'brand-' + appBrand]">
        <span class="fall-state-icon" aria-hidden="true"></span>
        <span class="fall-verify-badge" aria-hidden="true">&#10003;</span>
        <div class="row">
            <div class="col-sm">
                <picture *ngIf="appBrand === 'TeleHear'; else brandLogo">
                    <img class="fall-management-logo" src="./assets/TeleHear.svg" alt="TeleHear" />
                </picture>

                <ng-template #brandLogo>
                    <img class="fall-management-logo" [src]="'./assets/' + appBrand + '-web.png'" [alt]="appBrand">
                </ng-template>
            </div>
        </div>
        <div class="row">
            <div class="col-sm">
                <wizard #fallOptOutContactWizard [showDefaultControls]="false" (currentStepIndexChange)="onCurrentStepChange($event)">
                    <wizard-step [nextAction]="verifyPhoneNumber()">
                        <div class="fall-management-text-center">
                            <h1 class="fall-title">
                                {{_catService.getString("CloudTray_FallManagement_FallOptOutContact_EnterPhoneNumberMessage")}}
                            </h1>
                            <p class="fall-copy">
                                {{_catService.getString("CloudTray_FallManagement_FallOptOutContact_VerificationCodeMessage")}}
                            </p>
                            <div class="fall-phone-input-group">
                                <input id="phoneNumber" type="tel" inputmode="tel" autocomplete="tel"
                                    [placeholder]="_catService.getString('CloudTray_FallManagement_Common_PhonePlaceholder')" [(ngModel)]="phoneNumber"
                                    (ngModelChange)="transformPhoneNumber();" class="form-control" />
                                <div class="fall-field-message">
                                    <label *ngIf="invalidPhoneNumber" style="color:red; font-size:12px; ">{{_catService.getString("CloudTray_FallManagement_FallOptOutContact_InvalidPhoneNumberError")}}</label>
                                </div>
                            </div>
                        </div>
                    </wizard-step>
                    <wizard-step [nextAction]="checkVerificationCode()">
                        <div class="fall-management-text-center">
                            <h1 class="fall-title">
                                {{_catService.getString("CloudTray_FallManagement_FallOptOutContact_TextMessageSent")}}
                            </h1>
                            <p class="fall-copy">
                                {{_catService.getString("CloudTray_FallManagement_FallOptOutContact_EnterCodeText")}}
                            </p>
                            <div style="margin:20px 0 20px 0; text-align: center;">
                                <input id="verificationCode" type="text" placeholder="{{_catService.getString('CloudTray_FallManagement_FallOptOutContact_VerificationCodePlaceHolder')}}" [(ngModel)]="verificationCode"
                                    style="min-width: 280px;width: auto;margin: auto;padding: auto;" class="form-control" (ngModelChange)="changeToUpperCase();" />
                                    <div style="height:20px;">
                                        <label *ngIf="invalidVerificationCode" style="color:red; font-size:12px; ">{{_catService.getString("CloudTray_FallManagement_FallOptOutContact_InvalidVerificationCodeError")}}</label>
                                    </div>
                            </div>
                        </div>
                    </wizard-step>
                    <wizard-step>
                        <div class="fall-management-text-center">
                            <h1 class="fall-title">
                                {{_catService.getString("CloudTray_FallManagement_FallOptOutContact_RemoveScreenText")}}
                            </h1>
                            <div class="fall-opt-out-contact-list">
                                <div class="fall-opt-out-contact-row" *ngFor="let item of contactMappingData">
                                    <span class="form-control fall-opt-out-contact-name">{{item.patientName}}</span>
                                    <button type="button" class="form-control fall-opt-out-remove-button" [ngClass]="getRemoveButtonClass(item)"
                                        [disabled]="item.isBusy" (click)="removeContact(item)">
                                        {{item.isBusy ? '' : _catService.getString("CloudTray_FallManagement_FallOptOutContact_RemoveButton")}}
                                        <i *ngIf="item.isBusy" class="fa fa-spinner fa-pulse fa-fw"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="fall-opt-out-empty-state" *ngIf="contactMappingData.length === 0">
                                <span class="form-control">{{_catService.getString("CloudTray_FallManagement_FallOptOutContact_NoUsers")}}</span>
                            </div>
                        </div>
                    </wizard-step>

                </wizard>

                <button *ngIf="currentStep < 3" [ngClass]="getWizardButtonClass()"
                    [disabled]="(currentStep === 1 && !isProperNumber()) || (currentStep === 2 && !verificationCode) || awaitingResponse" class="form-control" style="min-width:200px;width: auto;margin: auto;"
                    (click)="goToNextStep()">
                    {{_catService.getString("CloudTray_FallManagement_FallOptOutContact_SubmitText")}}
                </button>
            </div>
        </div>
    </div>
</loading-text-display>
